import { apiClient } from '../api/client';
import { API_ENDPOINTS } from '../api/endpoints';
import type { 
  SendOTPPayload, 
  SendOTPResponse, 
  VerifyOTPPayload, 
  VerifyOTPResponse,
  RequestLoginTokenPayload,
  RequestLoginTokenResponse,
  LoginWithTokenPayload,
  LoginWithTokenResponse,
  ValidateSSOPayload,
  ValidateSSOResponse,
  CountryCodesResponse
} from '../types';

export class AuthService {
  async sendOTP(payload: SendOTPPayload) {
    return apiClient.request<SendOTPResponse>(API_ENDPOINTS.auth.sendOTP, undefined, payload);
  }

  async verifyOTP(payload: VerifyOTPPayload) {
    return apiClient.request<VerifyOTPResponse>(API_ENDPOINTS.auth.verifyOTP, undefined, payload);
  }

  async requestLoginToken(payload: RequestLoginTokenPayload) {
    return apiClient.request<RequestLoginTokenResponse>(API_ENDPOINTS.auth.requestLoginToken, undefined, payload);
  }

  async loginWithToken(token: string) {
    const payload: LoginWithTokenPayload = {
      token,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    return apiClient.request<LoginWithTokenResponse>(API_ENDPOINTS.auth.loginWithToken, undefined, payload);
  }

  async validateSSO(payload: ValidateSSOPayload) {
    return apiClient.request<ValidateSSOResponse>(API_ENDPOINTS.auth.validateSSO, undefined, payload);
  }

  async checkLogin() {
    return apiClient.request<{ success: boolean }>(API_ENDPOINTS.auth.checkLogin);
  }

  async getCountryCodes() {
    return apiClient.request<CountryCodesResponse>(API_ENDPOINTS.auth.countryCodes);
  }
}

export const authService = new AuthService();
